import { cn } from '@lair-finance/util'
import { useAccount } from '@lair-finance/wagmi'
import { ChainImages } from '@/shared/config/chain.ts'

export function CurrentChain({ className }: { className?: string }) {
  const account = useAccount()
  const icon = account.chainId ? ChainImages[account.chainId] : undefined

  if (!icon) return null

  return (
    <div className={cn('inline-flex-center size-12 rounded-[8px] border border-greyscale-500 bg-greyscale-700', className)}>
      <img src={icon} width={24} height={24} className={'rounded-[8px]'} />
    </div>
  )
}
